import { __assign } from "tslib";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopover } from '../../../Popovers/redux/hooks';
import { PopoverType } from '../../../Popovers/redux/types';
import { getDeviationNotificationQueue } from '../../../DeviationPage/redux/helpers';
import AddToCollectionPopover from '../../_partials/AddToCollectionPopup';
import FavouriteButton from './FavouriteButton';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
var offsetModifier = [0, 20];
var FavouriteButtonWithPopover = function (props) {
    var _a;
    var isMobile = useContext(MobileContext);
    var actionBarType = props.actionBarType;
    var _b = usePopover(actionBarType === 'primary'
        ? PopoverType.ADD_TO_COLLECTION_PRIMARY
        : PopoverType.ADD_TO_COLLECTION_SECONDARY), popover = _b.popover, removePopover = _b.removePopover, togglePopover = _b.togglePopover;
    var notificationQueue = isMobile
        ? 'default'
        : getDeviationNotificationQueue(props.deviation);
    return (React.createElement(PositionOnlyPopperPopover, { popoverContent: React.createElement(AddToCollectionPopover, { collectibleDeviation: props.deviation, notificationQueue: notificationQueue, ignorePreselectedCollections: (_a = popover.params) === null || _a === void 0 ? void 0 : _a.ignorePreselectedCollections, onClose: removePopover }), placement: "bottom", isVisible: popover.isOpen, offsetModifier: offsetModifier, onClickOutside: isMobile ? undefined : removePopover },
        React.createElement(FavouriteButton, __assign({}, props, { onArrowClick: togglePopover }))));
};
FavouriteButtonWithPopover.displayName = 'FavouriteButtonWithPopover';
export default FavouriteButtonWithPopover;
//# sourceMappingURL=FavouriteButtonWithPopover.js.map